import { render, staticRenderFns } from "./FanLogs.vue?vue&type=template&id=665e06ee&scoped=true&"
import script from "./FanLogs.vue?vue&type=script&lang=js&"
export * from "./FanLogs.vue?vue&type=script&lang=js&"
import style0 from "./FanLogs.vue?vue&type=style&index=0&id=665e06ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e06ee",
  null
  
)

export default component.exports